import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import ButtonLintCode from '../_DESIGN/PropertiesPaneButtonLintCode.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import ButtonGenCode from '../components/PropertiesPaneButtonGenCode.jsx'
import Bm from '../BM/PropertiesControllerBm.jsx'
import Fm from '../FM/PropertiesControllerFm.jsx'
import Ss from '../SS/PropertiesControllerSs.jsx'
import Vm from '../VM/PropertiesControllerVm.jsx'
import DomainKnowledge from './PropertiesPaneControllerDomainKnowledge.jsx'
import ButtonGenerateCc from './PropertiesPaneButtonGenerateCc.jsx'
import ButtonGenerateRam from './PropertiesPaneButtonGenerateRam.jsx'
import Model from './ModelBd.mjs'

const PropertiesPaneBd = (props) => {
    return (
        <ProductPropertiesPane
            buttons={
                <>
                    <ButtonGenCode />
                    <ButtonLintCode />
                    <ButtonGenerateRam />
                    <ButtonGenerateCc />
                </>
            }

            controllers={
                <>
                    <Ss />
                    <Bm />
                    <Fm />
                    <Vm />
                    <Text prop="bdNo" />
                    <Text prop="bdName" />
                    <LongText prop="memo" />
                    <DomainKnowledge />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        'DtReferenceCall',
                        'BdReferenceCall',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}

export default PropertiesPaneBd
